var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { distanceInMeter } from '@/utils/DistanceUtils';
import GeolocationUtils from '@/utils/GeolocationUtils';
/**
 * Location 타입을 distanceInMeter 함수에서 사용하는 좌표 타입으로 변환
 */
export function convertLocationToCoordinates(location) {
    return {
        latitude: location.lat,
        longitude: location.lng,
    };
}
/**
 * 현재 위치와 대상 위치 간의 거리를 계산
 * @param targetLocation 대상 위치
 * @returns 거리(미터), 현재 위치를 가져올 수 없거나 대상 위치가 없으면 undefined
 */
export function getDistanceFromCurrentLocation(targetLocation) {
    return __awaiter(this, void 0, void 0, function* () {
        // targetLocation이 없으면 undefined 반환
        if (!targetLocation) {
            return undefined;
        }
        try {
            // 현재 위치 가져오기
            const currentPosition = yield GeolocationUtils.getCurrentPosition();
            const currentLocation = {
                latitude: currentPosition.coords.latitude,
                longitude: currentPosition.coords.longitude,
            };
            // 거리 계산
            const distance = distanceInMeter(currentLocation, convertLocationToCoordinates(targetLocation));
            return distance;
        }
        catch (e) {
            // 현재 위치를 가져올 수 없으면 undefined 반환
            return undefined;
        }
    });
}
